module.exports = __webpack_public_path__ + "static/img/68081N_5_C_20230614_LC.ca6c47a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/68081N_5_C_20230614_LC.png
// module id = MLga
// module chunks = 0